import { useMemo, useState } from 'react';
import { AutoComplete, AutoCompleteProps } from 'antd';
import { includes, map } from 'lodash';
import { DefaultOptionType } from 'antd/lib/select';
import { ChronicDiseaseEnum } from '../../../../uc-api-sdk';
import { ChronicDiseaseEnumComponent, getText } from '../../../../enumComponent/ChronicDiseaseEnumComponent/ChronicDiseaseEnumComponent';

export interface DiseaseHistoryConditionAutoCompleteComponentProps
  extends Omit<AutoCompleteProps, 'onChange'> {
  disabledOptions?: string[];
  onChange?: (value?: string, associatedEnum?: ChronicDiseaseEnum) => void;
}

export const DiseaseHistoryConditionAutoCompleteComponent = ({
  onChange,
  disabledOptions,
}: DiseaseHistoryConditionAutoCompleteComponentProps) => {
  const [options] = useState([
    ChronicDiseaseEnum.DIABETES,
    ChronicDiseaseEnum.HYPERTENSION,
    ChronicDiseaseEnum.PRE_DIABETES,
    ChronicDiseaseEnum.HYPERLIPIDEMIA,
    ChronicDiseaseEnum.CHRONIC_OBSTRUCTIVE_PULMONARY_DISEASE,
    ChronicDiseaseEnum.CONGESTIVE_HEART_FAILURE,
    ChronicDiseaseEnum.CHRONIC_KIDNEY_DISEASE,
  ]);

  const handleOnChange: AutoCompleteProps['onChange'] = (
    value,
    option
  ) => {
    const associatedEnum = (option as DefaultOptionType)?.associatedEnum;
    if (associatedEnum && disabledOptions?.includes(associatedEnum)) {
      // prevent adding disabled option
      onChange?.(value, undefined);
      return;
    }
    onChange?.(value, associatedEnum);
  };

  const processedOptions = useMemo(() => (
    map(options, (enumValue) => {
      const option = {
        value: getText(enumValue),
        label: <ChronicDiseaseEnumComponent value={enumValue} />,
        associatedEnum: enumValue,
      };
      if (includes(disabledOptions, enumValue)) {
        return {
          ...option,
          label: (
            <>
              <ChronicDiseaseEnumComponent value={enumValue} />
              <span className="ml5">(Added)</span>
            </>
          ),
          disabled: true,
        };
      }
      return option;
    })
  ), [disabledOptions]);

  return (
    <AutoComplete
      options={processedOptions}
      onChange={handleOnChange}
      className="w400"
    />
  );
};
